import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Race } from 'src/app/models/race';
import { SensorData, SensorReturnData } from 'src/app/models';
import { ProgressService } from 'src/app/services/progress.service';

@Component({
  selector: 'app-mark-returned-sensors',
  templateUrl: './mark-returned-sensors.component.html',
  styleUrls: ['./mark-returned-sensors.component.scss'],
})
export class MarkReturnedSensorsComponent implements OnInit {
  @ViewChild('inputField') inputField!: ElementRef;
  race!: Race;
  sensorsList: SensorData[] = [];
  message: string = 'Введите номер датчика:';
  chronoTag!: string;
  messageClass: string = '';
  showReturned: boolean = false;

  constructor(private dynamicDialogConfig: DynamicDialogConfig, private progressService: ProgressService) {}

  ngOnInit() {
    const { race } = this.dynamicDialogConfig.data;
    this.race = race;

    this.loadSensors();
  }

  loadSensors() {
    this.progressService
      .getChronoTagsList(this.race)
      .then((sensors) => {
        this.sensorsList = sensors.filter((sensor) => sensor.clTag);
        this.sensorsList.forEach((sensor) => {
          sensor.returned = false;
        });
      });
  }

  focusOnInput() {
    this.inputField.nativeElement.focus();
  }

  markSensor(event: KeyboardEvent) {
    if (event.key != 'Enter' || !this.chronoTag) return;

    const sensor = this.sensorsList.find((sensor) => sensor.clTag == +this.chronoTag);

    if (sensor) {
      const returnData: SensorReturnData = {
        rUid: this.race.rUid,
        number: sensor.clTag,
        time: new Date().getTime(),
      };

      this.progressService
        .markChronoTagAsReturned([returnData])
        .then((answer) => {
          // const sensorIdx = this.sensorsList.indexOf(sensor);
          // this.sensorsList.splice(sensorIdx, 1);
          sensor.returnedAt = new Date();
          this.messageClass = 'success';
          this.message = `Датчик ${this.chronoTag} отмечен`;
          this.chronoTag = '';
        });
    } else {
      this.messageClass = 'error';
      this.message = `Датчик ${this.chronoTag} отсутствует в списке`;
      this.chronoTag = '';
    }
  }
}
